function createNotificationContainer() {
  // Check if the notification container already exists
  let notificationContainer = document.getElementById('notification-container');

  // If not, create and append it to the body
  if (!notificationContainer) {
    notificationContainer = document.createElement('div');
    notificationContainer.id = 'notification-container';
    notificationContainer.style.position = 'fixed';
    notificationContainer.style.bottom = '10px';
    notificationContainer.style.right = '10px';
    notificationContainer.style.width = '300px';
    notificationContainer.style.zIndex = '9999';
    notificationContainer.style.display = 'flex';
    notificationContainer.style.flexDirection = 'column';
    notificationContainer.style.gap = '10px';

    document.body.appendChild(notificationContainer);
  }

  return notificationContainer;
}

function showNotification(message, type = 'error') {
  const notificationContainer = createNotificationContainer();

  // Create the notification element
  const notification = document.createElement('div');
  notification.classList.add('notification');

  notification.innerHTML = `
      <span>${message}</span>
      <span class="close-btn" style="position: absolute; top: 5px; right: 10px; cursor: pointer;">&times;</span>
  `;

  // Add some styles to the notification
  notification.style.position = 'relative';
  notification.style.padding = '16px';
  notification.style.backgroundColor = type === 'error' ? '#f44336' : type === 'success' ? '#4CAF50' : '#ff9800';
  notification.style.color = 'white';
  notification.style.borderRadius = '4px';
  notification.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.2)';
  notification.style.opacity = '1';
  notification.style.transition = 'opacity 0.5s ease-out';

  // Add close functionality
  notification.querySelector('.close-btn').onclick = function () {
    notification.style.opacity = 0;
    setTimeout(() => notification.remove(), 500); // Delay to allow fade-out
  };

  // Automatically remove the notification after 5 seconds
  setTimeout(() => {
    notification.style.opacity = 0;
    setTimeout(() => notification.remove(), 500);
  }, 5000);

  // Append the notification to the container
  notificationContainer.appendChild(notification);
}

// Example function to handle errors
export default function (error) {
  // Display the error notification, ensuring an error always triggers a message
  showNotification(error || 'An unknown error occurred', 'error');

  // Call any other interaction handlers if needed (like interactionBlocker)
}
